import React from 'react';
import { useSupport } from './AuthShell';
import { looksLikeEmail, isValidEmail } from '../../utils/emailValidator';

/**
 * Validation and feedback for the "E Code/ Email" field shared by the auth
 * screens. The field takes either identifier, so the email format is only
 * enforced once the value carries an "@".
 */
export const userKeyRules = [
  { required: true, message: 'E Code/Email is required' },
  {
    validator: (_: any, value: any) => {
      const key = String(value ?? '').trim();
      if (!key || !looksLikeEmail(key) || isValidEmail(key)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Enter a valid email address'));
    },
  },
];

/**
 * Whether the backend's "no such user" verdict applies to what is in the field
 * right now — `unknownKey` carries the key it was reached for, so a verdict for
 * an earlier keystroke never labels the current value. A malformed email is
 * excluded: the format rule above already speaks for that case.
 */
export const isKeyNotOnRecord = (typedKey: string, unknownKey: string | null): boolean => {
  const malformedEmail = looksLikeEmail(typedKey) && !isValidEmail(typedKey);
  return !malformedEmail && unknownKey === typedKey;
};

/**
 * Inline error shown under the field. Its own component so the support hook
 * resolves inside AuthShell's provider rather than above it.
 */
export const NoEmailOnRecord = () => {
  const openSupport = useSupport();
  return (
    <div className="login-field-error">
      No email found for this E Code/Email. Please{' '}
      <button type="button" className="login-link" onClick={openSupport}>
        contact IT support
      </button>{' '}
      to update your email ID to proceed.
    </div>
  );
};
